import { Paper, Stack } from "@mui/material";
import type { Dayjs } from "dayjs";

import { WearableAggregationToggle } from "./WearableAggregationToggle";
import type { WearableAggregationMode } from "./wearableMetricAggregation";
import { WearableDateRangeChips } from "./WearableDateRangeChips";
import { WearablePeriodDateRow } from "./WearablePeriodDateRow";

export interface WearableFilterBarProps {
  rangeDays: number;
  onRangeChange: (days: number) => void;
  periodLabel: string;
  periodEnd: Dayjs;
  today: Dayjs;
  loading: boolean;
  onPrevDay: () => void;
  onNextDay: () => void;
  onPickDate: (date: Dayjs) => void;
  aggregationMode?: WearableAggregationMode;
  onAggregationModeChange?: (mode: WearableAggregationMode) => void;
}

/** Faixa verde: chips de dias + data. Layout em coluna — não esmaga os chips. */
export function WearableFilterBar({
  rangeDays,
  onRangeChange,
  periodLabel,
  periodEnd,
  today,
  loading,
  onPrevDay,
  onNextDay,
  onPickDate,
  aggregationMode,
  onAggregationModeChange,
}: WearableFilterBarProps) {
  const showAggregationToggle =
    rangeDays > 1 && aggregationMode && onAggregationModeChange;

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        p: { xs: 1, sm: 1.25 },
        backgroundColor: "primary800.main",
        color: "white",
        borderRadius: 2,
        flexShrink: 0,
      }}
    >
      <Stack spacing={1.25} sx={{ width: "100%", minWidth: 0 }}>
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          useFlexGap
          sx={{ width: "100%", minWidth: 0 }}
        >
          <WearableDateRangeChips
            rangeDays={rangeDays}
            onChange={onRangeChange}
            disabled={loading}
            tone="onPrimary"
          />
          {showAggregationToggle ? (
            <WearableAggregationToggle
              value={aggregationMode}
              onChange={onAggregationModeChange}
              tone="onPrimary"
            />
          ) : null}
        </Stack>

        <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
          <WearablePeriodDateRow
            periodLabel={periodLabel}
            periodEnd={periodEnd}
            today={today}
            loading={loading}
            onPrevDay={onPrevDay}
            onNextDay={onNextDay}
            onPickDate={onPickDate}
          />
        </Stack>
      </Stack>
    </Paper>
  );
}
